"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgMeal = function SvgMeal(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.164 1.84c.272-.178.627-.184.937.047 1.808 1.342 4.271 4.982 4.519 10.555.029.649-.287 1.284-.902 1.57a9.525 9.525 0 0 1-1.878.63l.712 4.985c.083.578.013 1.142-.232 1.607-.248.47-.669.826-1.256.987-1.1.303-2.33-.421-2.33-1.625V2.69c0-.36.166-.677.43-.85ZM3.86 3.04a1.525 1.525 0 0 1 1.519-1.26h.132a.227.227 0 0 1 .227.237l-.201 4.437a.568.568 0 0 0 1.134.052l.205-4.51a.227.227 0 0 1 .227-.217h1.181c.122 0 .222.096.227.217l.205 4.51a.568.568 0 1 0 1.135-.052l-.202-4.437a.227.227 0 0 1 .227-.238h.132c.744 0 1.393.517 1.52 1.26.21 1.242.504 3.414.48 5.736a2.829 2.829 0 0 1-2.232 2.754 10.85 10.85 0 0 1-.62.12l.836 7.97c.125 1.194-.618 2.393-1.855 2.566-.16.022-.313.036-.443.036s-.283-.014-.443-.036c-1.237-.173-1.98-1.372-1.855-2.566l.837-7.97a10.93 10.93 0 0 1-.621-.12A2.829 2.829 0 0 1 3.38 8.775c-.024-2.322.27-4.493.48-5.735Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgMeal);
var _default = exports["default"] = Memo;